import { FC, ReactElement, useState } from 'react'
import classnames from 'classnames'

import { Icon, IconName } from '@/components/Icon/Icon'

import './Avatar.scss'

interface AvatarProps {
    className?: string
    icon?: IconName
    image?: string
    initials?: string
    name?: string
}

export const Avatar: FC<AvatarProps> = ({
    className = '',
    icon,
    image,
    initials,
    name = '',
}): ReactElement => {
    const [failedImage, setFailedImage] = useState<string>()
    const showImage = Boolean(image) && failedImage !== image
    const avatarClassName = classnames('avatar', {
        'avatar--has-image': showImage,
        'avatar--has-initials': ! showImage && initials,
        'avatar--has-icon': ! showImage && ! initials && icon,
    }, className)

    return (
        <span className={avatarClassName} aria-hidden={! showImage}>
            {showImage ? (
                <img
                    alt={name}
                    className="avatar__image"
                    src={image}
                    onError={() => setFailedImage(image)}
                />
            ) : initials ? (
                initials
            ) : icon ? (
                <Icon name={icon} className="avatar__icon" />
            ) : null}
        </span>
    )
}
